import { GroupOverviewContext } from "@shared/features/onboarding/GroupOverview.context";
import useGroupOverviewProvider from "@shared/features/onboarding/hooks/useGroupOverviewProvider";
import React, { FC, PropsWithChildren } from "react";

const GroupOverviewProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    signalsGroupId,
    setSignalsGroupId,
    displayedConfiguration,
    setDisplayedConfiguration,
    selectedConfiguration,
    setSelectedConfiguration,
    selectedAccountId,
    setSelectedAccountId,
    accounts,
    setAccounts,
  } = useGroupOverviewProvider();

  return (
    <GroupOverviewContext.Provider
      value={{
        signalsGroupId,
        setSignalsGroupId,
        displayedConfiguration,
        setDisplayedConfiguration,
        selectedConfiguration,
        setSelectedConfiguration,
        selectedAccountId,
        setSelectedAccountId,
        accounts,
        setAccounts,
      }}
    >
      {children}
    </GroupOverviewContext.Provider>
  );
};

export default GroupOverviewProvider;
